/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const palette: ThemeOptions = {
	palette: {
		primary: {
			main: '#2682E7', // TODO: DEFINE TO MOCKUP
			dark: '#0064C7', // TODO: DEFINE TO MOCKUP
			light: '#72B5FF', // TODO: DEFINE TO MOCKUP
			contrastText: '#ffffff', // TODO: DEFINE TO MOCKUP
		},
		secondary: {
			main: '#FF4900', // TODO: DEFINE TO MOCKUP
			dark: '#AB2326', // TODO: DEFINE TO MOCKUP
			light: '#C46D52', // TODO: DEFINE TO MOCKUP
			contrastText: '#ffffff',
		},
		text: {
			main: '#2C2C2C', // TODO: DEFINE TO MOCKUP
			primary: '#2C2C2C', // TODO: DEFINE TO MOCKUP
			secondary: '#929292', // TODO: DEFINE TO MOCKUP
			disabled: '#b5beca',
			highlight: '#93101c',
			alert: '#c10c0d',
			expandedMenu: '#2C2C2C',
		},
		base: {
			main: '#43484d',
			contrastText: '#ffffff',
		},
		action: {
			hover: '#f0f4f7',
			disabled: '#b5beca',
			disabledBackground: '#ddcfcf',
		},
		background: {
			main: '#FBFBFC', // TODO: DEFINE TO MOCKUP
			default: '#FBFBFC', // TODO: DEFINE TO MOCKUP
			paper: '#ffffff',
			transparency: 'cc', // used to combine hex colors with transparency (00-ff), e.g., #ffffffcc
			contrastText: '#43484d',
		},
		divider: 'rgba(0, 0, 0, 0.12)',
		border: {
			dark: '#4c5256',
			alert: '#c10c0d',
			footer: '#888',
		},
		textField: {
			border: '#660b13',
			borderHovered: '#3a060b',
			background: '#fdfdfd',
			disabledBackground: '#ddcfcf',
		},
		button: {
			primary: '#2682E7', // TODO: DEFINE TO MOCKUP
			primaryHover: '#0064C7', // TODO: DEFINE TO MOCKUP
			secondary: '#FF4900', // TODO: DEFINE TO MOCKUP
			secondaryHover: '#AB2326', // TODO: DEFINE TO MOCKUP
			contrastText: '#ffffff', // TODO: DEFINE TO MOCKUP
			disabled: '#75767a', // TODO: DEFINE TO MOCKUP
			disabledText: '#ffffff', // TODO: DEFINE TO MOCKUP
		},
		extraColors: {
			lightGreen: '#ECF3E7', // TODO: DEFINE TO MOCKUP
			darkGreen: '#0F8B3F', // TODO: DEFINE TO MOCKUP
			mediumGreen: '#49B245', // TODO: DEFINE TO MOCKUP
		},
	},
} as ThemeOptions;
